module.exports = __webpack_public_path__ + "static/media/Rounds-09.a1522fd6.png";